module.exports = __webpack_public_path__ + "img/ORIGAMI_WATERMELON.8326b5c1.png";